import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reports SPA route changes to Google Ads.
 *
 * The gtag.js snippet itself is plain HTML in index.html, injected by server.js
 * only when REACT_APP_GOOGLE_ADS_ID is set, so Google's tag detection finds it in
 * the served document and QA never reports traffic. That snippet's
 * gtag('config', ...) call already reports the first page, so the initial render
 * is skipped here to avoid counting it twice.
 */
export default function GoogleAdsTag() {
  const location = useLocation();
  const path = location.pathname + location.search;
  const reported = useRef(path);

  useEffect(() => {
    if (!window.gtag || reported.current === path) return;
    reported.current = path;
    window.gtag("event", "page_view", { page_path: path });
  }, [path]);

  return null;
}
